import userSessionStorage from "./userSessionStorage"
import { sha256 } from 'js-sha256';

const encrypt =(string)=>{
    let hash = sha256.create();    
    string=hash.update(string);
    return string.hex()
}

const encryptUserInfo= () =>{
    const userSession =  new userSessionStorage()
    const userInfo = userSession.getUserInfo()
    let name, lastName, cellPhone, email, city, countryState, log_status
    if(userInfo){
        name= userInfo.name||'';
        lastName= userInfo.lastName||'';
        cellPhone= userInfo.cellPhone||'';
        email= userInfo.email||'';
        city= userInfo.location?.cityName||'';
        countryState= userInfo.location?.countryStateName||'';


        const user_data= [{
            name: encrypt(name),
            lastName: encrypt(lastName),
            cellPhone: encrypt(cellPhone),
            email: encrypt(email),
            city: encrypt(city),
            countryState: encrypt(countryState),
        }]
        log_status= 'Yes'
        return {user_data, log_status}

    }else{
        log_status='No';
        return {log_status}
    }
}

export {encryptUserInfo}
